import { render, staticRenderFns } from "./ScientificDegreeEdit.vue?vue&type=template&id=13836216&scoped=true&"
import script from "./ScientificDegreeEdit.vue?vue&type=script&lang=js&"
export * from "./ScientificDegreeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13836216",
  null
  
)

export default component.exports